import { useState } from 'react';

import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Popover from '@mui/material/Popover';

import StyledButton from '@webclient/components/search-forms/gamification-search/actions/bots-selector/sections/category-selector/styles';

import CONFIG from '@webclient/lib/const/bots';

import { AllBotsCategoryType } from '@webclient/shared-types/bots';

import CheckRoundedIcon from '~icons/knowz-iconify/check-rounded';
import ChevDown from '~icons/knowz-iconify/chev-down';

type Props = {
  handleFilterByCategory: (category: AllBotsCategoryType) => void;
  currentSelectedCategory: AllBotsCategoryType;
};

export default function CategorySelector({
  handleFilterByCategory,
  currentSelectedCategory,
}: Props) {
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  function handleSelectCategory(value: AllBotsCategoryType) {
    handleFilterByCategory(value);
    handleClose();
  }

  return (
    <>
      <StyledButton
        endIcon={<ChevDown />}
        onClick={handleClick}
        disableElevation
        disableFocusRipple
        disableRipple
        disableTouchRipple
      >
        {currentSelectedCategory}
      </StyledButton>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        <List
          disablePadding
          sx={{
            width: 230,
          }}
        >
          {CONFIG.ALL_CATEGORIES.map(({ icon, name, value }, index) => {
            return (
              <ListItemButton
                onClick={() => handleSelectCategory(value)}
                key={`${value}-${index}`}
              >
                <ListItem
                  disableGutters
                  disablePadding
                >
                  <ListItemIcon sx={{ fontSize: '0.9em' }}>{icon}</ListItemIcon>
                  <ListItemText
                    primaryTypographyProps={{
                      variant: 'textSm',
                      color: 'text.secondary',
                    }}
                  >
                    {name}
                  </ListItemText>
                  {currentSelectedCategory === value && <CheckRoundedIcon />}
                </ListItem>
              </ListItemButton>
            );
          })}
        </List>
      </Popover>
    </>
  );
}
